import { useDefaultAppContexts } from '@hivebrite/frontoffice-default-app-contexts';
// No Topic -> network routing
// Topic FO -> topic routing
// Topic PO (non WL) -> topic routing
// Topic PO + WL -> network routing
export const getNewsShowRoute = ({ id, topicId, userId, whitelabelActivated = false, whitelabelName, }) => {
    const isFO = Boolean(userId);
    const isWL = Boolean(whitelabelActivated && whitelabelName);
    const isTopic = Boolean(topicId);
    if (isTopic && (!isWL || isFO)) {
        return `/topics/${topicId}/news/${id}`;
    }
    return `/news/${id}`;
};
export const useNewsRouter = () => {
    const { currentTopic, currentUser } = useDefaultAppContexts();
    return {
        getNewsShowRoute: (id) => getNewsShowRoute({
            id,
            userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
            topicId: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.id,
            whitelabelActivated: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.whitelabelActivated,
            whitelabelName: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.whitelabelName,
        }),
    };
};
//# sourceMappingURL=useNewsRouter.js.map